import * as i0 from '@angular/core';
import { Injectable, Component, Inject, EventEmitter, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/platform-browser';
import moment from 'moment';
import * as i3$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i6 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i7 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from '@angular/router';
import * as i5 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i2$1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i8 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i10 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';

class ListaNotificacoesService {
    constructor() { }
    static ɵfac = function ListaNotificacoesService_Factory(t) { return new (t || ListaNotificacoesService)(); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ListaNotificacoesService, factory: ListaNotificacoesService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListaNotificacoesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

class NotificacoesService {
    http;
    URL;
    token;
    modo;
    sessao;
    aplicacaoId;
    headers;
    constructor(http) {
        this.http = http;
    }
    setModo(modo, token, sessao, aplicacaoId) {
        this.modo = modo;
        this.token = token;
        this.sessao = sessao;
        this.aplicacaoId = aplicacaoId;
        this.headers = {
            headers: {
                Authorization: this.token
                //"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImVmMjkxMzg4LTdiNzYtNDU1NS05ODQ0LTVmNWZlMjY0OWIyYyIsImFkbWluIjp0cnVlLCJhdGl2byI6dHJ1ZSwibm9tZSI6Ildlc2xleSBGcmFjYXJpIiwiZW1haWwiOiJ3ZXNsZXkuaW5mb2NhcEBnbWFpbC5jb20iLCJjb3JyZXRvcmFJZCI6ImNlMWIyOTAzLWEwYTgtNDk5ZC04MWY1LWZmOGI0ZTlkNjk4ZiIsImZvbmVDb3JyZXRvcmEiOiI1MTk5NTE5Mjc0OCIsImVtYWlsQ29ycmV0b3JhIjoiY29ycmV0b3Jhc291emFAZ21haWwuY29tIiwiY29ycmV0b3JhIjoiQ29ycmV0b3JhIFNvdXphIDIiLCJjb3JDZXAiOiI5MzgwNDYwNCIsImNvckxvZ3JhZG91cm8iOiJSdWEgQmVydGhvbGRvIFJvbm5hdSIsImNvck51bWVybyI6IjM1NiIsImNvckJhaXJybyI6Ik9lc3RlIiwiY29yQ29tcGxlbWVudG8iOiJTYWxhIDIxMSIsImNvckNpZGFkZSI6IlNhcGlyYW5nYSIsImNvclVGIjoiUlMiLCJsaWNlbmNhIjoiMjAyMS0wOC0wNSIsInF0ZGVMaWNlbmNhIjoxMCwibGljZW5jYUNvcnRlc2lhIjpudWxsLCJzdGF0dXNDb3JyZXRvcmEiOjEsInBhcmNlaXJvX2lkIjpudWxsLCJjcmVhdGVkQXQiOiIyMDE5LTExLTI5VDEyOjQzOjMzLjAwMFoiLCJyb290Ijp0cnVlLCJleHBpcmVzIjoxNjI2MjA3NTAyNjg2LCJpYXQiOjE2MjYxOTY3MDJ9.KTq6zObd_np8I67liINhGls34cTuDVNUly4oGRh6InU"
            }
        };
        if (this.aplicacaoId === 3) {
            if (this.modo === 'dev') {
                this.URL = 'https://dev-api.apice.app/';
            }
            else {
                this.URL = 'https://api.apice.app/';
            }
        }
        else if (this.aplicacaoId === 1) {
            //pegar o link das apis do multi
            if (this.modo === 'dev') {
                this.URL = '';
            }
            else {
                this.URL = '';
            }
        }
        // console.log({
        //   modo: this.modo,
        //   token: this.token,
        //   sessao: this.sessao,
        //   aplicacaoId: this.aplicacaoId,
        //   headers: this.headers,
        //   url: this.URL
        // })
    }
    buscaTodasNotificacoes() {
        return this.http.get(this.URL + 'notificacoes/busca-notificacoes', this.headers).toPromise();
    }
    buscaNotificacaoById(id) {
        return this.http.get(this.URL + `notificacoes/busca-notificacoes?id=${id}`, this.headers).toPromise();
    }
    criaAlteraNotificacao(body) {
        return this.http.post(this.URL + 'notificacoes/post-notificacoes', body, this.headers).toPromise();
    }
    marcarLido(body) {
        return this.http.post(this.URL + 'notificacoes/marcar-lido', body, this.headers).toPromise();
    }
    excluiNotificacao(id) {
        return this.http.delete(this.URL + `notificacoes/deleta-notificacao/${id}`, this.headers).toPromise();
    }
    static ɵfac = function NotificacoesService_Factory(t) { return new (t || NotificacoesService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificacoesService, factory: NotificacoesService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificacoesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.HttpClient }], null); })();

class NotificacoesUtilsService {
    apiNotificacoes;
    moment = moment;
    constructor(apiNotificacoes) {
        this.apiNotificacoes = apiNotificacoes;
    }
    notificacaoNaoLidasQtde = 0;
    verificaNotNaoLida(lista) {
        if (this.notificacaoNaoLidasQtde != 0) {
            this.notificacaoNaoLidasQtde = 0;
        }
        // debugger
        lista.forEach(n => {
            if (n.notificacoesUsuarios) {
                if (!n.notificacoesUsuarios?.dataLeitura) {
                    //caso for notificacao para allianz
                    this.notificacaoNaoLidasQtde += 1;
                }
            }
            else {
                //caso for notificacao para todos
                this.notificacaoNaoLidasQtde += 1;
            }
        });
        // console.log('this.notificacaoNaoLidasQtde', this.notificacaoNaoLidasQtde)
    }
    dataAtual = this.moment().locale('pt-br');
    tipoText = {
        1: 'Mensagem',
        2: 'Atualização',
        3: 'Alerta',
        4: 'Novidades'
    };
    formatarNotificacoes(lista) {
        lista.forEach(n => {
            n.descricao.iconOrImg = n.descricao.img === "" ? 'icon' : 'img';
            if (n.descricao.iconOrImg === 'icon') {
                if (n.descricao.tipo === 1) {
                    n.descricao.icon = 'email-outline';
                }
                else if (n.descricao.tipo === 2) {
                    n.descricao.icon = 'update';
                }
                else if (n.descricao.tipo === 3) {
                    n.descricao.icon = 'comment-alert-outline';
                }
                else if (n.descricao.tipo === 4) {
                    n.descricao.icon = 'newspaper-variant-outline';
                }
            }
            // n.descricao.img = n.descricao.img === "" && this.apiNotificacoes.aplicacaoId === 3 ? '../../assets/images/logo_apice.png' : n.descricao.img === "" && this.apiNotificacoes.aplicacaoId === 1 ? '../../assets/images/logo_multi.png' : n.descricao.img
            if (n.notificacoesUsuarios) {
                n.notificacoesUsuarios.lida = n.notificacoesUsuarios?.dataLeitura ? true : false;
            }
            n.tempoCriacaoNotificacao = this.dataAtual.diff(this.moment(n.dataIni), 'hours');
            if (n.tempoCriacaoNotificacao >= 24) {
                n.tempoCriacaoNotificacao = this.dataAtual.diff(this.moment(n.dataIni).locale('pt-br'), 'days') != 1 ? `Há ${this.dataAtual.diff(this.moment(n.dataIni).locale('pt-br'), 'days')} dias` : `Há ${this.dataAtual.diff(this.moment(n.dataIni).locale('pt-br'), 'days')} dia`;
            }
            else if (n.tempoCriacaoNotificacao < 24 && n.tempoCriacaoNotificacao != 0) {
                n.tempoCriacaoNotificacao = `Há ${this.dataAtual.diff(this.moment(n.dataIni).locale('pt-br'), 'hours')} horas`;
            }
            else if (n.tempoCriacaoNotificacao === 0) {
                n.tempoCriacaoNotificacao = `Há ${this.dataAtual.diff(this.moment(n.dataIni).locale('pt-br'), 'minutes')} min`;
            }
            n.descricao.tipoTxt = this.tipoText[n.descricao?.tipo];
        });
        lista.sort((a, b) => this.moment(b.dataIni) - this.moment(a.dataIni));
        // console.log(lista)
    }
    static ɵfac = function NotificacoesUtilsService_Factory(t) { return new (t || NotificacoesUtilsService)(i0.ɵɵinject(NotificacoesService)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificacoesUtilsService, factory: NotificacoesUtilsService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificacoesUtilsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: NotificacoesService }], null); })();

const _c0$2 = () => ({ "margin-left": "auto", "color": "#727272" });
const _c1$2 = () => ({ "margin-right": "8px" });
const _c2$1 = () => ({ "width": "25px", "height": "25px", "color": "#727272", "margin-bottom": "10px", "margin-right": "8px" });
function ModalDetalheNotificacaoComponent_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 11);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.data.descricao == null ? null : ctx_r0.data.descricao.img, i0.ɵɵsanitizeUrl)("ngStyle", i0.ɵɵpureFunction0(2, _c1$2));
} }
function ModalDetalheNotificacaoComponent_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 12);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("svgIcon", ctx_r0.data.descricao.icon)("ngStyle", i0.ɵɵpureFunction0(3, _c2$1))("matTooltip", ctx_r0.data.descricao.tipoTxt);
} }
function ModalDetalheNotificacaoComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ModalDetalheNotificacaoComponent_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.abrirLink(ctx_r0.data.descricao == null ? null : ctx_r0.data.descricao.link)); });
    i0.ɵɵtext(1, "Acessar link");
    i0.ɵɵelementEnd();
} }
class ModalDetalheNotificacaoComponent {
    data;
    dialogRef;
    dialog;
    apiNotificacoes;
    matIconRegistry;
    domSanitizer;
    constructor(data, dialogRef, dialog, apiNotificacoes, matIconRegistry, domSanitizer) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.dialog = dialog;
        this.apiNotificacoes = apiNotificacoes;
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.matIconRegistry.addSvgIcon("close", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/close.svg"));
        this.matIconRegistry.addSvgIcon("comment-alert-outline", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/comment-alert-outline.svg"));
        this.matIconRegistry.addSvgIcon("email-outline", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/email-outline.svg"));
        this.matIconRegistry.addSvgIcon("newspaper-variant-outline", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/newspaper-variant-outline.svg"));
        this.matIconRegistry.addSvgIcon("update", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/update.svg"));
        //esta função realiza a atualização da lista de notificacoes
        dialogRef.backdropClick().subscribe(() => {
            if (!this.data.notificacoesUsuarios?.lida) {
                this.dialogRef.close('fechou');
            }
        });
    }
    ngOnInit() {
        if (!this.data.notificacoesUsuarios || !this.data.notificacoesUsuarios?.lida) {
            // this.marcarLida(this.data.id)
        }
    }
    // marcouComoLida:boolean = this.data.notificacoesUsuarios?.lida === true ? true : false;
    // loadingLida:boolean = false;
    // async marcarLida(id) { 
    //   this.loadingLida = true;
    //   let body:object = {
    //     "notificacaoId": id,
    //     "marcarComoLido": true
    //   }
    //   try {
    //     let ret = await this.apiNotificacoes.marcarLido(body)
    //     if(ret) {
    //       this.loadingLida = false;
    //       this.marcouComoLida = true;
    //     }
    //   } catch (error) {
    //     console.error('erro ao marcar como lido', error)
    //     this.loadingLida = false;
    //   }
    // }
    fechar() {
        // debugger
        if (!this.data.notificacoesUsuarios?.lida) {
            this.dialogRef.close('fechou');
        }
        else {
            this.dialogRef.close();
        }
    }
    abrirLink(link) {
        window.open(link, '_blank');
    }
    static ɵfac = function ModalDetalheNotificacaoComponent_Factory(t) { return new (t || ModalDetalheNotificacaoComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(NotificacoesService), i0.ɵɵdirectiveInject(i3.MatIconRegistry), i0.ɵɵdirectiveInject(i4.DomSanitizer)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModalDetalheNotificacaoComponent, selectors: [["lib-modal-detalhe-notificacao"]], decls: 13, vars: 8, consts: [[1, "modal-notificacoes"], ["mat-dialog-title", "", 1, "modal-notificacoes__cabecalho"], [3, "src", "ngStyle", 4, "ngIf"], [3, "svgIcon", "ngStyle", "matTooltip", 4, "ngIf"], [1, "fontHelvetica16"], ["tabindex", "-1", "mat-icon-button", "", 3, "click", "ngStyle"], [3, "svgIcon"], ["mat-dialog-content", ""], [1, "fontDefault-lib"], ["mat-dialog-actions", "", 1, "modal-notificacoes__actions"], ["tabindex", "-1", "mat-button", "", "class", "btn-action-lib", 3, "click", 4, "ngIf"], [3, "src", "ngStyle"], [3, "svgIcon", "ngStyle", "matTooltip"], ["tabindex", "-1", "mat-button", "", 1, "btn-action-lib", 3, "click"]], template: function ModalDetalheNotificacaoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, ModalDetalheNotificacaoComponent_img_2_Template, 1, 3, "img", 2)(3, ModalDetalheNotificacaoComponent_mat_icon_3_Template, 1, 4, "mat-icon", 3);
            i0.ɵɵelementStart(4, "span", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "button", 5);
            i0.ɵɵlistener("click", function ModalDetalheNotificacaoComponent_Template_button_click_6_listener() { return ctx.fechar(); });
            i0.ɵɵelement(7, "mat-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 7)(9, "p", 8);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "div", 9);
            i0.ɵɵtemplate(12, ModalDetalheNotificacaoComponent_button_12_Template, 2, 0, "button", 10);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.data.descricao.iconOrImg === "img");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.descricao.iconOrImg === "icon");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.data.titulo, "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(7, _c0$2));
            i0.ɵɵadvance();
            i0.ɵɵproperty("svgIcon", "close");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.data.descricao == null ? null : ctx.data.descricao.texto);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.data.descricao == null ? null : ctx.data.descricao.link);
        } }, dependencies: [i3$1.NgIf, i3$1.NgStyle, i1$1.MatDialogTitle, i1$1.MatDialogActions, i1$1.MatDialogContent, i3.MatIcon, i6.MatTooltip, i7.MatButton, i7.MatIconButton], styles: [".modal-notificacoes[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column;padding:16px 0}.modal-notificacoes[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{letter-spacing:normal}.modal-notificacoes__cabecalho[_ngcontent-%COMP%]{display:flex;align-items:center;margin:0 0 16px}.modal-notificacoes__cabecalho[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{align-self:flex-end}.modal-notificacoes__cabecalho[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%], .modal-notificacoes__cabecalho[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{overflow:initial;width:25px;height:25px}.modal-notificacoes__actions[_ngcontent-%COMP%]{justify-content:flex-end;padding-right:30px}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalDetalheNotificacaoComponent, [{
        type: Component,
        args: [{ selector: 'lib-modal-detalhe-notificacao', template: "<div class=\"modal-notificacoes\">\r\n    <div mat-dialog-title class=\"modal-notificacoes__cabecalho\">\r\n        <img *ngIf=\"data.descricao.iconOrImg === 'img'\" [src]=\"data.descricao?.img\" [ngStyle]=\"{'margin-right': '8px'}\" />\r\n        <mat-icon *ngIf=\"data.descricao.iconOrImg === 'icon'\" [svgIcon]=\"data.descricao.icon\" [ngStyle]=\"{'width':'25px', 'height':'25px',  'color': '#727272', 'margin-bottom':'10px', 'margin-right': '8px'}\" [matTooltip]=\"data.descricao.tipoTxt\"></mat-icon>\r\n        <span class=\"fontHelvetica16\"> {{ data.titulo }}</span>\r\n        <button tabindex=\"-1\" mat-icon-button (click)=\"fechar()\" [ngStyle]=\"{'margin-left': 'auto',  'color': '#727272'}\">\r\n            <mat-icon [svgIcon]=\"'close'\"></mat-icon>\r\n        </button>\r\n    </div>\r\n    <div mat-dialog-content>\r\n        <p class=\"fontDefault-lib\">{{ data.descricao?.texto }}</p>\r\n    </div>\r\n    <div mat-dialog-actions class=\"modal-notificacoes__actions\">\r\n        <!-- <button mat-button class=\"btn-action-lib\" *ngIf=\"!marcouComoLida\" [disabled]=\"loadingLida\" (click)=\"marcarLida(data.id)\">Marcar como lida</button> -->\r\n        <!-- <button mat-button mat-dialog-close class=\"btn-action-lib\" (click)=\"fechar()\">Fechar</button> -->\r\n        <button tabindex=\"-1\" mat-button class=\"btn-action-lib\" *ngIf=\"data.descricao?.link\" (click)=\"abrirLink(data.descricao?.link)\">Acessar link</button>\r\n    </div>\r\n</div>", styles: [".modal-notificacoes{height:100%;display:flex;flex-direction:column;padding:16px 0}.modal-notificacoes *{letter-spacing:normal}.modal-notificacoes__cabecalho{display:flex;align-items:center;margin:0 0 16px}.modal-notificacoes__cabecalho button{align-self:flex-end}.modal-notificacoes__cabecalho mat-icon,.modal-notificacoes__cabecalho img{overflow:initial;width:25px;height:25px}.modal-notificacoes__actions{justify-content:flex-end;padding-right:30px}\n"] }]
    }], () => [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1$1.MatDialogRef }, { type: i1$1.MatDialog }, { type: NotificacoesService }, { type: i3.MatIconRegistry }, { type: i4.DomSanitizer }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ModalDetalheNotificacaoComponent, { className: "ModalDetalheNotificacaoComponent", filePath: "components\\modal-detalhe-notificacao\\modal-detalhe-notificacao.component.ts", lineNumber: 13 }); })();

const _c0$1 = () => ({ "padding": "0px" });
const _c1$1 = () => ({ "margin": "0" });
const _c2 = () => ({ "width": "25px", "height": "25px" });
function ItemNotificacaoComponent_mat_list_item_3_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 16);
} if (rf & 2) {
    const n_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", n_r2.descricao.img, i0.ɵɵsanitizeUrl)("ngStyle", i0.ɵɵpureFunction0(3, _c2))("matTooltip", n_r2.descricao.tipoTxt);
} }
function ItemNotificacaoComponent_mat_list_item_3_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 17);
} if (rf & 2) {
    const n_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("svgIcon", n_r2.descricao.icon)("matTooltip", n_r2.descricao.tipoTxt);
} }
function ItemNotificacaoComponent_mat_list_item_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-list-item", 4);
    i0.ɵɵlistener("click", function ItemNotificacaoComponent_mat_list_item_3_Template_mat_list_item_click_0_listener($event) { const n_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.checkNotificacao($event, n_r2)); });
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, ItemNotificacaoComponent_mat_list_item_3_img_2_Template, 1, 4, "img", 6)(3, ItemNotificacaoComponent_mat_list_item_3_mat_icon_3_Template, 1, 2, "mat-icon", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8)(5, "div", 9)(6, "p", 10);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 11)(9, "div", 12)(10, "p", 13);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 14)(13, "p", 15);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const n_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", (n_r2.notificacoesUsuarios == null ? null : n_r2.notificacoesUsuarios.lida) === true ? "opacityLida-lib" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", n_r2.descricao.iconOrImg === "img");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", n_r2.descricao.iconOrImg === "icon");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(9, _c1$1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(n_r2.titulo);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(10, _c1$1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(n_r2.descricao.texto);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(11, _c1$1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(n_r2.tempoCriacaoNotificacao);
} }
class ItemNotificacaoComponent {
    matIconRegistry;
    domSanitizer;
    titulo;
    arrayDados;
    abreNotificacao = new EventEmitter();
    constructor(matIconRegistry, domSanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.matIconRegistry.addSvgIcon("comment-alert-outline", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/comment-alert-outline.svg"));
        this.matIconRegistry.addSvgIcon("email-outline", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/email-outline.svg"));
        this.matIconRegistry.addSvgIcon("newspaper-variant-outline", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/newspaper-variant-outline.svg"));
        this.matIconRegistry.addSvgIcon("update", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/update.svg"));
    }
    ngOnInit() {
    }
    checkNotificacao(ev, notificacao) {
        this.abreNotificacao.emit(notificacao);
    }
    static ɵfac = function ItemNotificacaoComponent_Factory(t) { return new (t || ItemNotificacaoComponent)(i0.ɵɵdirectiveInject(i3.MatIconRegistry), i0.ɵɵdirectiveInject(i4.DomSanitizer)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ItemNotificacaoComponent, selectors: [["lib-item-notificacao"]], inputs: { titulo: "titulo", arrayDados: [i0.ɵɵInputFlags.None, "dados", "arrayDados"] }, outputs: { abreNotificacao: "abreNotificacao" }, decls: 4, vars: 3, consts: [[1, "lib-item-notificacao"], [1, "lib-item-notificacao__titulo"], [1, "lib-item-notificacao__content", 3, "ngStyle"], ["class", "lib-item-notificacao__item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "lib-item-notificacao__item", 3, "click", "ngClass"], [1, "img"], ["class", "icon-notificacao", 3, "src", "ngStyle", "matTooltip", 4, "ngIf"], ["class", "icon-notificacao", 3, "svgIcon", "matTooltip", 4, "ngIf"], [1, "infos"], [1, "infos__titulo"], [1, "fontDefault-lib", "textOverflow-lib", 3, "ngStyle"], [1, "infos__subInfos"], [1, "subInfos-1"], [1, "fontSmall-lib", "textOverflow-lib", 3, "ngStyle"], [1, "subInfos-2"], [1, "fontSmall-lib", 3, "ngStyle"], [1, "icon-notificacao", 3, "src", "ngStyle", "matTooltip"], [1, "icon-notificacao", 3, "svgIcon", "matTooltip"]], template: function ItemNotificacaoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementStart(2, "mat-nav-list", 2);
            i0.ɵɵtemplate(3, ItemNotificacaoComponent_mat_list_item_3_Template, 15, 12, "mat-list-item", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(2, _c0$1));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.arrayDados);
        } }, dependencies: [i3$1.NgClass, i3$1.NgForOf, i3$1.NgIf, i3$1.NgStyle, i3.MatIcon, i6.MatTooltip, i5.MatNavList, i5.MatListItem], styles: [".lib-item-notificacao{width:100%;display:flex;align-items:center;height:auto;flex-direction:column;padding:8px 0 0}  .lib-item-notificacao *{letter-spacing:normal}  .lib-item-notificacao__titulo{display:flex;width:100%;padding:0 8px}  .lib-item-notificacao__content{max-width:100%;height:auto!important;padding:0 16px!important}  .lib-item-notificacao__content .lib-item-notificacao__item{border-top:none;min-height:48px}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content{height:auto!important}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text{width:100%;display:flex;align-items:center;height:auto}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text mat-list-item span span{display:flex}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .img{width:15%;padding-right:4px;display:flex;align-self:center}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .img .icon-notificacao{width:25px!important;height:25px!important;color:#727272!important}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .img img{width:10px;height:10px}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos{width:85%;height:auto}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos__subInfos{display:flex;width:100%}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos__subInfos .subInfos-1{display:flex;width:65%}  .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos__subInfos .subInfos-2{display:flex;width:35%}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItemNotificacaoComponent, [{
        type: Component,
        args: [{ selector: 'lib-item-notificacao', template: "<div class=\"lib-item-notificacao\">\r\n    <div class=\"lib-item-notificacao__titulo\">\r\n        <!-- <p class=\"fontHelvetica15\">{{ titulo }} ({{ arrayDados.length }})</p> -->\r\n    </div>\r\n    <mat-nav-list [ngStyle]=\"{'padding':'0px'}\" class=\"lib-item-notificacao__content\">\r\n        <mat-list-item class=\"lib-item-notificacao__item\" *ngFor=\"let n of arrayDados\" (click)=\"checkNotificacao($event, n)\" [ngClass]=\"n.notificacoesUsuarios?.lida === true ? 'opacityLida-lib' : ''\">\r\n                <div class=\"img\">\r\n                    <img *ngIf=\"n.descricao.iconOrImg === 'img'\" class=\"icon-notificacao\" [src]=\"n.descricao.img\" [ngStyle]=\"{'width':'25px', 'height':'25px'}\" [matTooltip]=\"n.descricao.tipoTxt\" />\r\n                    <mat-icon class=\"icon-notificacao\" *ngIf=\"n.descricao.iconOrImg === 'icon'\" [svgIcon]=\"n.descricao.icon\"  [matTooltip]=\"n.descricao.tipoTxt\"></mat-icon>\r\n                </div>\r\n                <div class=\"infos\">\r\n                    <div class=\"infos__titulo\">\r\n                        <p class=\"fontDefault-lib textOverflow-lib\" [ngStyle]=\"{'margin': '0'}\">{{ n.titulo }}</p>\r\n                    </div>\r\n                    <div class=\"infos__subInfos\">\r\n                        <div class=\"subInfos-1\">\r\n                            <p class=\"fontSmall-lib textOverflow-lib\" [ngStyle]=\"{'margin': '0'}\">{{ n.descricao.texto }}</p>\r\n                        </div>\r\n                        <div class=\"subInfos-2\">\r\n                            <p class=\"fontSmall-lib\" [ngStyle]=\"{'margin': '0'}\">{{ n.tempoCriacaoNotificacao }}</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n        </mat-list-item>\r\n    </mat-nav-list>\r\n</div>\r\n", styles: ["::ng-deep .lib-item-notificacao{width:100%;display:flex;align-items:center;height:auto;flex-direction:column;padding:8px 0 0}::ng-deep .lib-item-notificacao *{letter-spacing:normal}::ng-deep .lib-item-notificacao__titulo{display:flex;width:100%;padding:0 8px}::ng-deep .lib-item-notificacao__content{max-width:100%;height:auto!important;padding:0 16px!important}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item{border-top:none;min-height:48px}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content{height:auto!important}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text{width:100%;display:flex;align-items:center;height:auto}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text mat-list-item span span{display:flex}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .img{width:15%;padding-right:4px;display:flex;align-self:center}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .img .icon-notificacao{width:25px!important;height:25px!important;color:#727272!important}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .img img{width:10px;height:10px}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos{width:85%;height:auto}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos__subInfos{display:flex;width:100%}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos__subInfos .subInfos-1{display:flex;width:65%}::ng-deep .lib-item-notificacao__content .lib-item-notificacao__item .mdc-list-item__content .mdc-list-item__primary-text .infos__subInfos .subInfos-2{display:flex;width:35%}\n"] }]
    }], () => [{ type: i3.MatIconRegistry }, { type: i4.DomSanitizer }], { titulo: [{
            type: Input,
            args: ['titulo']
        }], arrayDados: [{
            type: Input,
            args: ['dados']
        }], abreNotificacao: [{
            type: Output,
            args: ['abreNotificacao']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ItemNotificacaoComponent, { className: "ItemNotificacaoComponent", filePath: "components\\item-notificacao\\item-notificacao.component.ts", lineNumber: 11 }); })();

function ListaComponent_lib_item_notificacao_7_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-item-notificacao", 7);
    i0.ɵɵlistener("abreNotificacao", function ListaComponent_lib_item_notificacao_7_Template_lib_item_notificacao_abreNotificacao_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.checkNotificacao($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dados", ctx_r1.listaNotificacoes)("titulo", "Mensagens");
} }
function ListaComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 9);
    i0.ɵɵtext(2, "N\u00E3o h\u00E1 notifica\u00E7\u00F5es!");
    i0.ɵɵelementEnd()();
} }
class ListaComponent {
    apiNotificacoes;
    router;
    dialog;
    matIconRegistry;
    domSanitizer;
    utilsNotificacoes;
    moment = moment;
    listaNotificacoes = [];
    loadingAfterClose = new EventEmitter();
    constructor(apiNotificacoes, router, dialog, matIconRegistry, domSanitizer, utilsNotificacoes) {
        this.apiNotificacoes = apiNotificacoes;
        this.router = router;
        this.dialog = dialog;
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.utilsNotificacoes = utilsNotificacoes;
        this.matIconRegistry.addSvgIcon("format-list-bulleted", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/format-list-bulleted.svg"));
    }
    dataAtual = this.moment().locale('pt-br');
    tipoText = {
        1: 'Mensagem',
        2: 'Atualização',
        3: 'Alerta',
        4: 'Novidades'
    };
    notificacoesMsg = [];
    notificacoesAtt = [];
    notificacoesAlerts = [];
    notificacoesNews = [];
    ngOnInit() {
        this.formatNotificacoes();
    }
    formatNotificacoes() {
        this.utilsNotificacoes.formatarNotificacoes(this.listaNotificacoes);
        this.utilsNotificacoes.verificaNotNaoLida(this.listaNotificacoes);
    }
    async checkNotificacao(notificacao) {
        if (!notificacao.notificacoesUsuarios || !notificacao.notificacoesUsuarios?.lida) {
            let body = {
                "notificacaoId": notificacao.id,
                "marcarComoLido": true
            };
            try {
                let ret = await this.apiNotificacoes.marcarLido(body);
            }
            catch (error) {
                console.error('erro ao marcar como lida', error);
            }
        }
        let modal = this.dialog.open(ModalDetalheNotificacaoComponent, {
            panelClass: ['modalDefaultP-lib'],
            data: notificacao,
            width: '400px'
        });
        modal.afterClosed().subscribe(async (data) => {
            if (data && data === 'fechou') {
                this.loadingAfterClose.emit(true);
            }
        });
    }
    abrirTodas() {
        let rota = this.apiNotificacoes.aplicacaoId === 3 ? '/notificacoes' : '';
        this.router.navigateByUrl(rota);
    }
    static ɵfac = function ListaComponent_Factory(t) { return new (t || ListaComponent)(i0.ɵɵdirectiveInject(NotificacoesService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i3.MatIconRegistry), i0.ɵɵdirectiveInject(i4.DomSanitizer), i0.ɵɵdirectiveInject(NotificacoesUtilsService)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ListaComponent, selectors: [["lib-lista"]], inputs: { listaNotificacoes: "listaNotificacoes" }, outputs: { loadingAfterClose: "loadingAfterClose" }, decls: 9, vars: 3, consts: [[1, "lista-notificacoes-lib"], [1, "notificacao-title-lib"], [1, "fontHelvetica16"], ["mat-button", "", 3, "click", "disabled"], [1, "btn-todas"], [3, "dados", "titulo", "abreNotificacao", 4, "ngIf"], ["class", "lista-notificacoes-lib__vazia", 4, "ngIf"], [3, "abreNotificacao", "dados", "titulo"], [1, "lista-notificacoes-lib__vazia"], [1, "fontDefault"]], template: function ListaComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
            i0.ɵɵtext(3, "Notifica\u00E7\u00F5es");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 3);
            i0.ɵɵlistener("click", function ListaComponent_Template_button_click_4_listener() { return ctx.abrirTodas(); });
            i0.ɵɵelementStart(5, "span", 4);
            i0.ɵɵtext(6, "Ver todas");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(7, ListaComponent_lib_item_notificacao_7_Template, 1, 2, "lib-item-notificacao", 5)(8, ListaComponent_div_8_Template, 3, 0, "div", 6);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("disabled", ctx.listaNotificacoes.length === 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.listaNotificacoes.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.listaNotificacoes.length === 0);
        } }, dependencies: [i3$1.NgIf, ItemNotificacaoComponent, i7.MatButton], styles: [".lista-notificacoes-lib[_ngcontent-%COMP%]{max-height:300px;height:auto;padding-bottom:4px;margin-bottom:4px}.lista-notificacoes-lib[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{letter-spacing:normal}.lista-notificacoes-lib[_ngcontent-%COMP%]   .btn-todas[_ngcontent-%COMP%]{color:#176bff}.lista-notificacoes-lib[_ngcontent-%COMP%]   .notificacao-title-lib[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:space-between;align-items:center;padding:0 4px;border-bottom:1px solid rgba(0,0,0,.12)}.lista-notificacoes-lib[_ngcontent-%COMP%]   .notificacao-title-lib[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding:0 0 0 4px}.lista-notificacoes-lib[_ngcontent-%COMP%]   .notificacao-title-lib[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{align-self:flex-end}.lista-notificacoes-lib__vazia[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;padding-top:16px}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListaComponent, [{
        type: Component,
        args: [{ selector: 'lib-lista', template: "<div class=\"lista-notificacoes-lib\">\r\n    <div class=\"notificacao-title-lib\">\r\n        <span class=\"fontHelvetica16\">Notifica\u00E7\u00F5es</span>\r\n        <button mat-button  (click)=\"abrirTodas()\" [disabled]=\"listaNotificacoes.length === 0\">\r\n            <span class=\"btn-todas\">Ver todas</span>\r\n        </button>\r\n    </div>\r\n    <lib-item-notificacao *ngIf=\"listaNotificacoes.length > 0\" [dados]=\"listaNotificacoes\" [titulo]=\"'Mensagens'\" (abreNotificacao)=\"checkNotificacao($event);\"></lib-item-notificacao>\r\n    \r\n    <div *ngIf=\"listaNotificacoes.length === 0\" class=\"lista-notificacoes-lib__vazia\">\r\n        <span class=\"fontDefault\">N\u00E3o h\u00E1 notifica\u00E7\u00F5es!</span>\r\n    </div>\r\n</div>", styles: [".lista-notificacoes-lib{max-height:300px;height:auto;padding-bottom:4px;margin-bottom:4px}.lista-notificacoes-lib *{letter-spacing:normal}.lista-notificacoes-lib .btn-todas{color:#176bff}.lista-notificacoes-lib .notificacao-title-lib{width:100%;display:flex;justify-content:space-between;align-items:center;padding:0 4px;border-bottom:1px solid rgba(0,0,0,.12)}.lista-notificacoes-lib .notificacao-title-lib span{padding:0 0 0 4px}.lista-notificacoes-lib .notificacao-title-lib button{align-self:flex-end}.lista-notificacoes-lib__vazia{display:flex;justify-content:center;align-items:center;padding-top:16px}\n"] }]
    }], () => [{ type: NotificacoesService }, { type: i2.Router }, { type: i1$1.MatDialog }, { type: i3.MatIconRegistry }, { type: i4.DomSanitizer }, { type: NotificacoesUtilsService }], { listaNotificacoes: [{
            type: Input,
            args: ['listaNotificacoes']
        }], loadingAfterClose: [{
            type: Output,
            args: ['loadingAfterClose']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListaComponent, { className: "ListaComponent", filePath: "components\\lista\\lista.component.ts", lineNumber: 18 }); })();

class LoadingPageComponent {
    diameter = '40';
    color = 'ef712a';
    constructor() { }
    ngOnInit() {
    }
    static ɵfac = function LoadingPageComponent_Factory(t) { return new (t || LoadingPageComponent)(); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoadingPageComponent, selectors: [["loading-page"]], inputs: { diameter: "diameter", color: "color" }, decls: 2, vars: 2, consts: [["ngClass", "loading-page-lib"], ["id", "matSpinner", "strokeWidth", "4", 3, "diameter", "color"]], template: function LoadingPageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "mat-spinner", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("diameter", ctx.diameter)("color", ctx.color);
        } }, dependencies: [i3$1.NgClass, i2$1.MatProgressSpinner], styles: [".loading-page-lib[_ngcontent-%COMP%]{align-self:center;justify-self:center;background:#fff;border-radius:50px;padding:8px;box-shadow:0 6px 23px -8px #000000d9;z-index:999}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingPageComponent, [{
        type: Component,
        args: [{ selector: 'loading-page', template: "<div ngClass=\"loading-page-lib\">\r\n    <mat-spinner\r\n        id=\"matSpinner\"\r\n        strokeWidth=\"4\"\r\n        [diameter]=\"diameter\"\r\n        [color]=\"color\"></mat-spinner>\r\n</div>\r\n", styles: [".loading-page-lib{align-self:center;justify-self:center;background:#fff;border-radius:50px;padding:8px;box-shadow:0 6px 23px -8px #000000d9;z-index:999}\n"] }]
    }], () => [], { diameter: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoadingPageComponent, { className: "LoadingPageComponent", filePath: "components\\loading-page\\loading-page.component.ts", lineNumber: 8 }); })();

const _c0 = () => ({ "color": "#fff" });
const _c1 = () => ({ "height": "60px", "display": "flex", "align-itens": "center", "justify-content": "center" });
function ListaNotificacoesComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matBadge", ctx_r1.utilsNotificacoes.notificacaoNaoLidasQtde)("matBadgeColor", ctx_r1.apiNotificacoes.aplicacaoId === 3 ? "warn" : "primary")("matBadgePosition", "above after")("matBadgeSize", "medium");
} }
function ListaNotificacoesComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "loading-page", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(2, _c1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r1.corLoading);
} }
function ListaNotificacoesComponent_lib_lista_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-lista", 11);
    i0.ɵɵlistener("loadingAfterClose", function ListaNotificacoesComponent_lib_lista_7_Template_lib_lista_loadingAfterClose_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.loadingAfterClose($event)); })("click", function ListaNotificacoesComponent_lib_lista_7_Template_lib_lista_click_0_listener($event) { i0.ɵɵrestoreView(_r3); $event.stopPropagation(); return i0.ɵɵresetView($event.preventDefault()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("listaNotificacoes", ctx_r1.lista);
} }
class ListaNotificacoesComponent {
    apiNotificacoes;
    matIconRegistry;
    domSanitizer;
    utilsNotificacoes;
    corLoading = 'accent';
    aplicacaoID;
    constructor(apiNotificacoes, matIconRegistry, domSanitizer, utilsNotificacoes) {
        this.apiNotificacoes = apiNotificacoes;
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.utilsNotificacoes = utilsNotificacoes;
        this.matIconRegistry.addSvgIcon("bell", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/bell.svg"));
        this.matIconRegistry.addSvgIcon("bell-outline", this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/bell-outline.svg"));
    }
    ngOnInit() { }
    setModo(modo, token, sessao, aplicacaoId) {
        this.apiNotificacoes.setModo(modo, token, sessao, aplicacaoId);
        this.aplicacaoID = aplicacaoId;
        this.getNotificacoes(true);
    }
    menuAberto = false;
    mostrarLista;
    lista = [];
    async abrirMenu() {
        this.menuAberto = true;
        this.mostrarLista = false;
        await this.getNotificacoes();
        if (this.todasNotificacoes) {
            this.mostrarLista = true;
            this.lista = this.todasNotificacoes;
        }
    }
    todasNotificacoes;
    async getNotificacoes(primeiraVez) {
        try {
            let ret = await this.apiNotificacoes.buscaTodasNotificacoes();
            if (ret) {
                if (primeiraVez) {
                    this.utilsNotificacoes.verificaNotNaoLida(ret);
                }
                else {
                    this.todasNotificacoes = ret;
                    this.utilsNotificacoes.verificaNotNaoLida(this.todasNotificacoes);
                    this.utilsNotificacoes.formatarNotificacoes(this.todasNotificacoes);
                }
            }
        }
        catch (error) {
            console.error('erro ao buscar as notificacoes', error);
        }
    }
    async loadingAfterClose(ev) {
        // this.mostrarLista = false;
        // this.lista = [];
        await this.getNotificacoes();
        await this.utilsNotificacoes.formatarNotificacoes(this.todasNotificacoes);
        this.mostrarLista = true;
        this.lista = this.todasNotificacoes;
    }
    static ɵfac = function ListaNotificacoesComponent_Factory(t) { return new (t || ListaNotificacoesComponent)(i0.ɵɵdirectiveInject(NotificacoesService), i0.ɵɵdirectiveInject(i3.MatIconRegistry), i0.ɵɵdirectiveInject(i4.DomSanitizer), i0.ɵɵdirectiveInject(NotificacoesUtilsService)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ListaNotificacoesComponent, selectors: [["lib-lista-notificacoes"]], decls: 8, vars: 7, consts: [["menuNotficacao", "matMenu"], [1, "notificacoesBtn-lib"], ["mat-icon-button", "", "matRipple", "", "matTooltip", "Notificac\u00F5es", 3, "menuOpened", "menuClosed", "matMenuTriggerFor"], [3, "ngStyle", "svgIcon"], [3, "matBadge", "matBadgeColor", "matBadgePosition", "matBadgeSize", 4, "ngIf"], ["xPosition", "before", 1, "menu-notificacao-lib"], [3, "ngStyle", 4, "ngIf"], [3, "listaNotificacoes", "loadingAfterClose", "click", 4, "ngIf"], [3, "matBadge", "matBadgeColor", "matBadgePosition", "matBadgeSize"], [3, "ngStyle"], [3, "color"], [3, "loadingAfterClose", "click", "listaNotificacoes"]], template: function ListaNotificacoesComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
            i0.ɵɵlistener("menuOpened", function ListaNotificacoesComponent_Template_button_menuOpened_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.abrirMenu()); })("menuClosed", function ListaNotificacoesComponent_Template_button_menuClosed_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.menuAberto = false); });
            i0.ɵɵelement(2, "mat-icon", 3);
            i0.ɵɵtemplate(3, ListaNotificacoesComponent_span_3_Template, 1, 4, "span", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-menu", 5, 0);
            i0.ɵɵtemplate(6, ListaNotificacoesComponent_div_6_Template, 2, 3, "div", 6)(7, ListaNotificacoesComponent_lib_lista_7_Template, 1, 1, "lib-lista", 7);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const menuNotficacao_r4 = i0.ɵɵreference(5);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matMenuTriggerFor", menuNotficacao_r4);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(6, _c0))("svgIcon", "bell");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.utilsNotificacoes.notificacaoNaoLidasQtde != 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.mostrarLista);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mostrarLista);
        } }, dependencies: [i3$1.NgIf, i3$1.NgStyle, ListaComponent, LoadingPageComponent, i8.MatMenu, i8.MatMenuTrigger, i7.MatIconButton, i3.MatIcon, i10.MatBadge], styles: [".menu-notificacao-lib[_ngcontent-%COMP%]   .mat-mdc-menu-panel[_ngcontent-%COMP%]{position:relative;right:300px;max-height:300px;height:auto;width:280px;max-width:280px;min-width:280px}.notificacoesBtn-lib[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{color:#fff!important;font-size:12px}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListaNotificacoesComponent, [{
        type: Component,
        args: [{ selector: 'lib-lista-notificacoes', template: "<div class=\"notificacoesBtn-lib\">\r\n    <button\r\n        mat-icon-button\r\n        matRipple\r\n        (menuOpened)=\"abrirMenu()\"\r\n        (menuClosed)=\"menuAberto = false\"\r\n        [matMenuTriggerFor]=\"menuNotficacao\"\r\n        matTooltip=\"Notificac\u00F5es\">\r\n            <mat-icon [ngStyle]=\"{'color':'#fff'}\" [svgIcon]=\"'bell'\"></mat-icon>\r\n            <span *ngIf=\"utilsNotificacoes.notificacaoNaoLidasQtde != 0\" [matBadge]=\"utilsNotificacoes.notificacaoNaoLidasQtde\" [matBadgeColor]=\"apiNotificacoes.aplicacaoId === 3 ? 'warn' : 'primary'\" [matBadgePosition]=\"'above after'\" [matBadgeSize]=\"'medium'\"></span>\r\n    </button>\r\n</div>\r\n<mat-menu xPosition=\"before\" class=\"menu-notificacao-lib\" #menuNotficacao=\"matMenu\">\r\n    <div *ngIf=\"!mostrarLista\" [ngStyle]=\"{'height':'60px', 'display':'flex', 'align-itens':'center', 'justify-content':'center'}\">\r\n        <loading-page [color]=\"corLoading\"></loading-page>\r\n    </div>\r\n    <lib-lista *ngIf=\"mostrarLista\" [listaNotificacoes]=\"lista\" (loadingAfterClose)=\"loadingAfterClose($event)\" (click)=\"$event.stopPropagation();$event.preventDefault();\"></lib-lista>\r\n</mat-menu>\r\n\r\n\r\n", styles: [".menu-notificacao-lib .mat-mdc-menu-panel{position:relative;right:300px;max-height:300px;height:auto;width:280px;max-width:280px;min-width:280px}.notificacoesBtn-lib .mat-badge-content{color:#fff!important;font-size:12px}\n"] }]
    }], () => [{ type: NotificacoesService }, { type: i3.MatIconRegistry }, { type: i4.DomSanitizer }, { type: NotificacoesUtilsService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ListaNotificacoesComponent, { className: "ListaNotificacoesComponent", filePath: "lib\\lista-notificacoes.component.ts", lineNumber: 12 }); })();

class ModalDetalheNotificacaoModule {
    static ɵfac = function ModalDetalheNotificacaoModule_Factory(t) { return new (t || ModalDetalheNotificacaoModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ModalDetalheNotificacaoModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatDialogModule,
            MatIconModule,
            MatTooltipModule,
            MatButtonModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalDetalheNotificacaoModule, [{
        type: NgModule,
        args: [{
                declarations: [ModalDetalheNotificacaoComponent],
                imports: [
                    CommonModule,
                    MatDialogModule,
                    MatIconModule,
                    MatTooltipModule,
                    MatButtonModule
                ],
                exports: [ModalDetalheNotificacaoComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ModalDetalheNotificacaoModule, { declarations: [ModalDetalheNotificacaoComponent], imports: [CommonModule,
        MatDialogModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule], exports: [ModalDetalheNotificacaoComponent] }); })();

class ItemNotificacaoModule {
    static ɵfac = function ItemNotificacaoModule_Factory(t) { return new (t || ItemNotificacaoModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ItemNotificacaoModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ModalDetalheNotificacaoModule,
            MatIconModule,
            MatTooltipModule,
            MatListModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItemNotificacaoModule, [{
        type: NgModule,
        args: [{
                declarations: [ItemNotificacaoComponent],
                imports: [
                    CommonModule,
                    ModalDetalheNotificacaoModule,
                    MatIconModule,
                    MatTooltipModule,
                    MatListModule,
                ],
                exports: [ItemNotificacaoComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ItemNotificacaoModule, { declarations: [ItemNotificacaoComponent], imports: [CommonModule,
        ModalDetalheNotificacaoModule,
        MatIconModule,
        MatTooltipModule,
        MatListModule], exports: [ItemNotificacaoComponent] }); })();

class ListaModule {
    static ɵfac = function ListaModule_Factory(t) { return new (t || ListaModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ListaModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ModalDetalheNotificacaoModule,
            ItemNotificacaoModule,
            MatListModule,
            MatTooltipModule,
            MatButtonModule,
            MatIconModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListaModule, [{
        type: NgModule,
        args: [{
                declarations: [ListaComponent],
                imports: [
                    CommonModule,
                    ModalDetalheNotificacaoModule,
                    ItemNotificacaoModule,
                    MatListModule,
                    MatTooltipModule,
                    MatButtonModule,
                    MatIconModule
                ],
                exports: [ListaComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ListaModule, { declarations: [ListaComponent], imports: [CommonModule,
        ModalDetalheNotificacaoModule,
        ItemNotificacaoModule,
        MatListModule,
        MatTooltipModule,
        MatButtonModule,
        MatIconModule], exports: [ListaComponent] }); })();

class LoadingPageModule {
    static ɵfac = function LoadingPageModule_Factory(t) { return new (t || LoadingPageModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LoadingPageModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatProgressSpinnerModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingPageModule, [{
        type: NgModule,
        args: [{
                declarations: [LoadingPageComponent],
                imports: [
                    CommonModule,
                    MatProgressSpinnerModule
                ],
                exports: [LoadingPageComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LoadingPageModule, { declarations: [LoadingPageComponent], imports: [CommonModule,
        MatProgressSpinnerModule], exports: [LoadingPageComponent] }); })();

class ListaNotificacoesModule {
    static ɵfac = function ListaNotificacoesModule_Factory(t) { return new (t || ListaNotificacoesModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ListaNotificacoesModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            ListaModule,
            LoadingPageModule,
            MatMenuModule,
            MatButtonModule,
            MatIconModule,
            MatBadgeModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListaNotificacoesModule, [{
        type: NgModule,
        args: [{
                declarations: [ListaNotificacoesComponent],
                imports: [
                    CommonModule,
                    ListaModule,
                    LoadingPageModule,
                    MatMenuModule,
                    MatButtonModule,
                    MatIconModule,
                    MatBadgeModule
                ],
                exports: [ListaNotificacoesComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ListaNotificacoesModule, { declarations: [ListaNotificacoesComponent], imports: [CommonModule,
        ListaModule,
        LoadingPageModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatBadgeModule], exports: [ListaNotificacoesComponent] }); })();

/*
 * Public API Surface of lista-notificacoes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ListaNotificacoesComponent, ListaNotificacoesModule, ListaNotificacoesService };
